import { globalSaga } from "@/containers/global/saga";
import { landingSaga } from "@/containers/landing/saga";
import { parcelDetailSaga } from "@/containers/parcelDetail/saga";
import { parcelsSaga } from "@/containers/parcels/saga";
import { runSaga } from "@/store/configureStore";

/**
 * Every feature saga is started here, once, at store creation.
 * Add yours alongside `globalSaga`.
 *
 * checkout, myFarm and admin have no saga — see the note in `store/reducers.ts`.
 */
export const runSagas = () => {
  runSaga(globalSaga);
  runSaga(landingSaga);
  runSaga(parcelsSaga);
  runSaga(parcelDetailSaga);
};
